var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGpsFixed24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_gps_fixed_24px",
    d: "M10,6.727A3.273,3.273,0,1,0,13.273,10,3.272,3.272,0,0,0,10,6.727Zm7.315,2.455a7.359,7.359,0,0,0-6.5-6.5V1H9.182V2.685a7.359,7.359,0,0,0-6.5,6.5H1v1.636H2.685a7.359,7.359,0,0,0,6.5,6.5V19h1.636V17.315a7.359,7.359,0,0,0,6.5-6.5H19V9.182H17.315ZM10,15.727A5.727,5.727,0,1,1,15.727,10,5.723,5.723,0,0,1,10,15.727Z",
    transform: "translate(-1 -1)",
    fill: "#354a5f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGpsFixed24Px);
export default __webpack_public_path__ + "static/media/ic_gps_fixed_24px.984a91bfed4b82c6b4ff3a81e052d739.svg";
export { ForwardRef as ReactComponent };